import View from 'view/view'
import Router from 'service/router'
import ModalView from 'component/modal/modal'
import currentUser from 'shared/model/current_user'

export default View.extend({
    options: {
        trigger: '.js-interests-teaser-trigger',
    },
    initialize() {
        const {
            options: { trigger },
        } = this
        this.$(trigger).on('click', () => {
            this.initSubview(ModalView, {
                name: 'interests',
                url: Router.path('profile_teaser_interest_edit', {
                    user: currentUser.get('id'),
                }),
                fullHeight: true,
            })
        })
    },
})
